<template>
  <v-container class="fill-height">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <v-card class="px-sm-1 px-0 withbg mx-auto shadowCard" max-width="600">
          <v-card-title primary-title>
            <v-spacer></v-spacer>
            <v-img src="@/assets/logo.png" max-width="250"></v-img>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
              Usuario
            </div>
              
            <v-text-field
              v-model="correo"
              label="usuario@fithouse.com"
              filled
              dense
              required
              color="primary"
              single-line
              prepend-inner-icon="mdi-email-outline"
            ></v-text-field>

            <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
              Contraseña

              <a
                class="text-caption text-decoration-none text-red"
                href="#"
                rel="noopener noreferrer"
                target="_blank"
              >
                Olvidaste tu contraseña?</a>
            </div>
            <v-text-field
              v-model="pass"
              label="*******"
              type="password"
              filled
              dense
              required
              color="primary"
              single-line
              :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="validate()"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-btn
              tile
              type="submit"
              block
              color="primary"
              class="mt-4 btn-login text-capitalize"
              @click="validate()"
            >
              Iniciar sesión
            </v-btn>
          </v-card-actions>
          <v-card-text class="text-center">
            <a
              class="text-red text-decoration-none"
              rel="noopener noreferrer"
              @click="registrarme()"
            >
              Registrarme ahora <v-icon icon="mdi-chevron-right"></v-icon>
            </a>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Dialog de carga -->
      <Alerta               v-if="respuestaAlerta"          :parametros="parametros"/>
      <carga                v-if="cargar"/>

    </v-row>
  </v-container>
</template>
<script>

  // import router from '@/router'
  import {mapActions , mapGetters} from 'vuex'

   // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    data(){
      return{
        pass: '',
        correo:'',
        showPassword: false,
      }
    },

    computed:{
      ...mapGetters('login',['getdatosUsuarioFitHouse']),
    },

    async created(){
      await this.initialize()
    },

    methods:{

      ...mapActions('login',['guardarInfo']),

      initialize() {

        if( this.getdatosUsuarioFitHouse ){
          this.$router.push({name: 'Perfil'})
        }
      },

      validate(){
        if( this.correo && this.pass ){
          this.cargar = true

          var usuario = { correo : this.correo, pass: this.pass}
          this.$http.post('usuarios.validate',usuario).then((response) => {
            this.guardarInfo( response.body )
            this.cargar = false
            this.$router.push({name: 'Perfil'})
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }else{
          this.validarErrorDirecto('Favor de llenar los datos completos')
        }
      },

      registrarme(){
        this.$router.push({name: 'Registro' })
      }
    }
  }
</script>
<style>
  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }

  .text-muted{
    color: rgb(var(--v-theme-muted)) !important;
  }

  body {
    font-family: 'Plus Jakarta Sansa', sans-serif !important;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }

  .btn-login{
    background: rgb(255,19,19);
    background: linear-gradient(90deg, rgba(255,19,19,1) 21%, rgba(0,0,0,1) 77%);
  }
</style>